<script>
    import ModifyEmail from './ModifyEmail';
    import ModifyPassword from './ModifyPassword';

    export default {
        name: "UserProfile",
        components: {
            ModifyEmail,
            ModifyPassword
        },
        props: [
            'userprop',
            'companyprop'
        ],
        data() {
            const fiscal_file = typeof this.userprop.fiscal_file !== 'undefined' && this.userprop.fiscal_file 
                ? this.userprop.fiscal_file : { fiscal_code: '' }

            return {
                user: {
                    ...this.userprop,
                    fiscal_file
                },
                company: {},
                validationErrors: {
                    first_name: false,
                    last_name: false,
                    fiscal_code: false
                },
                message: null,
                modify: false,
            }
        },
        mounted() {
            this.company = this.companyprop
        },
        watch: {
            'user': {
                handler: function (val, oldVal) {
                    this.message = null;
                },
                deep: true
            }
        },
        methods: {
            modifyEmail() {
                this.$emit('modify-email');
            },
            modifyPassword() {
                this.$emit('modify-password');
            },
            postForm() {
                this.message = null;

                if (this.validation()) {
                    axios({
                        method: 'put',
                        url: '/users/' + this.user.id,
                        data: {
                            first_name: this.user.first_name,
                            last_name: this.user.last_name,
                            fiscal_code: this.user.fiscal_file.fiscal_code.toUpperCase(),
                            birthday: this.user.birthday
                        }
                    }).then((response) => {
                        this.user.first_name = response.data.user.first_name
                        this.user.last_name = response.data.user.last_name
                        this.user.fiscal_file.fiscal_code = response.data.user.fiscal_file.fiscal_code
                        this.message = 'Saved'
                        window.toastr.success("Profilo salvato correttamente");
                    }).catch((error) => {
                        console.log(error);
                        if (error && error.response && error.response.status && error.response.status === 422) {
                            this.validationErrors = error.response.data.errors;
                            this.$emit('init-error', 'Impossibile salvare i dati');
                        }
                        else {
                            this.$emit('init-error', 'Internal server error');
                        }
                    });
                }
            },
            modifyEmail() {
                this.modify = 'email';
                window.location.hash = '#email';
            },
            modifyPassword() {
                this.modify = 'password';
                window.location.hash = '#password';
            },
            resetModify() {
                this.modify = null;
                window.location.hash = '#account';
            },
            initError(message) {
                window.alerts.error(message);
            },
            initSuccess(message) {
                window.alerts.success(message)
            },
            validation() {
                let passed = true
                this.validationErrors = {
                    first_name: false,
                    last_name: false,
                    fiscal_code: false,
                }

                if (!this.user.first_name) {
                    this.validationErrors.first_name = true
                    passed = false
                }

                if (!this.user.last_name) {
                    this.validationErrors.last_name = true
                    passed = false;
                }

                if (!this.user.fiscal_file.fiscal_code) {
                    this.validationErrors.fiscal_code = true
                    passed = false;
                }

                if (!passed) {
                    window.scrollTo(0, 200);
                }

                return passed;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/UserProfile.vue